import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-logout",
  "use": "icon-logout-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-logout\"><path d=\"M10 11v1c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1V4c0-.6.4-1 1-1h4c.6 0 1 .4 1 1v1h1V4c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2v-1z\" /><path d=\"m12.5 4.8-.7.7 2 2H7v1h6.8l-2 2 .7.7L15.7 8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol